import React from 'react';

// The bare <video>, and nothing else. Composition — the rotation frame, the
// control bar, fullscreen, the keyboard shortcuts — is VideoStage's job, and
// this stays dumb so there is exactly one element to hand a ref to.
//
// `controls` now defaults OFF, and every in-app surface leaves it off: the app
// draws its own bar (VideoControlBar) so that a rotated and an unrotated
// project look the same. The native bar also cannot survive rotation at all —
// it lives in the element's user-agent shadow DOM, so a CSS transform turns the
// play button and scrubber along with the picture. The prop is kept for the
// marketing surfaces, which are outside this and want the browser's own.
const VideoPlayer = React.forwardRef(({
  src, onTimeUpdate, onPlay, onError, controls = false,
}, ref) => {
  return (
    <div>
      <video
        key={src}
        controls={controls}
        controlsList="nodownload noplaybackrate nopictureinpicture noremoteplayback"
        disablePictureInPicture
        disableRemotePlayback
        playsInline
        preload="auto"
        style={{ width: '100%' }}
        ref={ref}
        onTimeUpdate={onTimeUpdate}
        onPlay={onPlay}
        onError={onError}
      >
        {/* No onError on the <source>, deliberately. Natively, a video that
            gets its media from a <source> child reports a load/decode failure
            on the <source>, and that event does not bubble — so the handler
            looks like it belongs here too. It does not: react-dom attaches its
            own 'error' listener to every <source> element it creates and then
            dispatches the synthetic event up the fiber tree, so the <video>'s
            onError above already runs for a failure raised on the <source>.
            A second handler here would only make one failure call back twice. */}
        <source src={src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
});

export default VideoPlayer;
